(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('toggle', (event) => {
    const item = event.target;
    if (!item.matches?.('.section-faq .faq-item') || !item.open) return;
    item.closest('.section-faq').querySelectorAll('details[open]').forEach((other) => { if (other !== item) other.open = false; });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veylston-guide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('toggle', (event) => {
    const item = event.target;
    if (!item.matches?.('.v-guide__item') || !item.open) return;
    item.closest('[data-v-faq-group]').querySelectorAll('details[open]').forEach((other) => { if (other !== item) other.open = false; });
  }, true);
  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target.closest('.v-guide__item');
    if (item) item.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veylston-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('v-campaign')) {
  customElements.define('v-campaign', class extends HTMLElement {
    connectedCallback() {
      if (this.ready || !this.hasAttribute('data-preview')) return;
      const options = [...this.querySelectorAll('[data-campaign-variant]')];
      const image = this.querySelector('[data-campaign-image]');
      if (!options.length || !image) return;
      this.ready = true;
      let request = 0;
      const group = this.querySelector('[data-campaign-variants]');
      const title = this.querySelector('[data-campaign-title]');
      const price = this.querySelector('[data-campaign-price]');
      const availability = this.querySelector('[data-campaign-availability]');
      const cta = this.querySelector('[data-campaign-cta]');
      const status = this.querySelector('[data-campaign-status]');
      group.setAttribute('role', 'radiogroup');
      const select = async (option) => {
        const current = ++request;
        this.setAttribute('data-loading', '');
        const next = new Image();
        next.sizes = image.sizes;
        next.srcset = option.dataset.srcset;
        next.src = option.dataset.image;
        try { await next.decode(); } catch { if (current === request) this.removeAttribute('data-loading'); return; }
        if (current !== request || !this.isConnected) return;
        image.srcset = option.dataset.srcset;
        image.src = option.dataset.image;
        image.alt = option.dataset.imageAlt;
        title.textContent = option.dataset.title;
        price.textContent = option.dataset.price;
        availability.hidden = option.dataset.available === 'true';
        if (cta && !this.hasAttribute('data-custom-link')) cta.href = option.href;
        options.forEach((item) => {
          const selected = item === option;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-checked', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        status.textContent = `${option.dataset.title}, ${option.dataset.price}${availability.hidden ? '' : ', ' + availability.textContent}`;
        this.removeAttribute('data-loading');
      };
      options.forEach((option, index) => {
        const selected = option.classList.contains('is-selected');
        option.setAttribute('role', 'radio');
        option.setAttribute('aria-checked', String(selected));
        option.tabIndex = selected ? 0 : -1;
        option.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey || event.button > 0) return;
          event.preventDefault();
          select(option);
        });
        option.addEventListener('keydown', (event) => {
          let next = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % options.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + options.length) % options.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = options.length - 1;
          else if (event.key !== ' ') return;
          event.preventDefault();
          options[next].focus();
          select(options[next]);
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veylston-product-aftercare"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('v-product-faq')) {
  customElements.define('v-product-faq', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.animations = new Map();
      this.closing = new Set();
      const signal = this.controller.signal;
      this.addEventListener('click', (event) => {
        const summary = event.target.closest('.v-aftercare__question');
        if (!summary || !this.contains(summary)) return;
        event.preventDefault();
        const item = summary.parentElement;
        this.setExpanded(item, !item.open || this.closing.has(item));
      }, { signal });
      this.addEventListener('toggle', (event) => {
        const item = event.target;
        if (!item.classList.contains('v-aftercare__item')) return;
        if (item.open) this.closeOthers(item);
        else this.clearAnimation(item);
      }, { capture: true, signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.animations?.forEach((animation, item) => this.clearAnimation(item));
    }
    clearAnimation(item) {
      this.animations.get(item)?.cancel();
      this.animations.delete(item);
      this.closing.delete(item);
      item.style.overflow = '';
    }
    closeOthers(current) {
      this.querySelectorAll('.v-aftercare__item[open]').forEach((item) => {
        if (item === current) return;
        this.clearAnimation(item);
        item.open = false;
      });
    }
    setExpanded(item, expanded) {
      const startHeight = item.getBoundingClientRect().height;
      this.clearAnimation(item);
      if (expanded) {
        this.closeOthers(item);
        item.open = true;
      }
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !item.animate) {
        item.open = expanded;
        return;
      }
      const summary = item.querySelector('.v-aftercare__question');
      const endHeight = expanded ? item.getBoundingClientRect().height : summary.getBoundingClientRect().height + 2;
      if (!expanded) this.closing.add(item);
      item.style.overflow = 'hidden';
      const animation = item.animate(
        [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
        { duration: 220, easing: 'cubic-bezier(.2,.7,.2,1)' }
      );
      this.animations.set(item, animation);
      animation.onfinish = () => {
        if (this.animations.get(item) !== animation) return;
        item.open = expanded;
        this.clearAnimation(item);
      };
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veylston-product-controls"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('v-product-controls')) {
    customElements.define('v-product-controls', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enhanced) return;
        const tabList = this.querySelector('[data-v-control-tabs]');
        const gallery = this.querySelector('[data-v-control-gallery]');
        const tabs = Array.from(this.querySelectorAll('[data-v-control-tab]'));
        const panels = Array.from(this.querySelectorAll('[data-v-control-panel]'));
        if (!tabList || !gallery || !tabs.length || tabs.length !== panels.length) return;
        const figures = panels.map((panel) => {
          const figure = panel.querySelector('[data-v-control-image]');
          if (figure) gallery.appendChild(figure);
          return figure;
        });
        const activate = (index, focusTab) => {
          tabs.forEach((tab, position) => {
            const selected = position === index;
            tab.setAttribute('aria-selected', String(selected));
            tab.tabIndex = selected ? 0 : -1;
            panels[position].hidden = !selected;
            if (figures[position]) figures[position].hidden = !selected;
          });
          gallery.hidden = !figures[index];
          if (focusTab) tabs[index].focus();
        };
        tabList.setAttribute('role', 'tablist');
        tabList.setAttribute('aria-orientation', 'vertical');
        tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', tab.dataset.vControlTab);
          panels[index].setAttribute('role', 'tabpanel');
          panels[index].setAttribute('aria-labelledby', tab.id);
          panels[index].tabIndex = 0;
          tab.addEventListener('click', () => activate(index, false));
          tab.addEventListener('keydown', (event) => {
            let next = index;
            if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = tabs.length - 1;
            else return;
            event.preventDefault();
            activate(next, true);
          });
        });
        this.dataset.enhanced = 'true';
        activate(0, false);
        tabList.hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veylston-product-details"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('v-product-details')) {
    customElements.define('v-product-details', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enhanced) return;
        const tabList = this.querySelector('[data-v-tabs]');
        const tabs = Array.from(this.querySelectorAll('[data-v-tab]'));
        const panels = Array.from(this.querySelectorAll('[data-v-panel]'));
        if (!tabList || !tabs.length || tabs.length !== panels.length) return;
        const activate = (index, focusTab) => {
          tabs.forEach((tab, position) => {
            const selected = position === index;
            tab.setAttribute('aria-selected', String(selected));
            tab.tabIndex = selected ? 0 : -1;
            panels[position].hidden = !selected;
          });
          if (focusTab) tabs[index].focus();
        };
        tabList.setAttribute('role', 'tablist');
        tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', tab.dataset.vTab);
          panels[index].setAttribute('role', 'tabpanel');
          panels[index].setAttribute('aria-labelledby', tab.id);
          panels[index].tabIndex = 0;
          tab.addEventListener('click', () => activate(index, false));
          tab.addEventListener('keydown', (event) => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = tabs.length - 1;
            else return;
            event.preventDefault();
            activate(next, true);
          });
        });
        activate(0, false);
        this.dataset.enhanced = 'true';
        tabList.hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veylston-product-overview"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('v-product-overview')) {
    customElements.define('v-product-overview', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        const panels = [...this.querySelectorAll('.v-overview__item')];
        const measure = (panel) => {
          const content = panel.querySelector('.v-overview__content');
          const height = content.getBoundingClientRect().height;
          if (height > 0) panel.style.setProperty('--v-overview-content-height', `${height}px`);
        };
        this.addEventListener('toggle', (event) => {
          const panel = event.target;
          if (!panels.includes(panel) || !panel.open) return;
          panels.forEach(other => { if (other !== panel) other.open = false; });
          measure(panel);
        }, {capture:true, signal:this.controller.signal});
        this.addEventListener('shopify:block:select', () => {
          if (panels[0]) { panels[0].open = true; measure(panels[0]); }
        }, {signal:this.controller.signal});
        this.observer = new ResizeObserver(entries => entries.forEach(entry => measure(entry.target.parentElement)));
        panels.forEach(panel => { measure(panel); this.observer.observe(panel.querySelector('.v-overview__content')); });
        this.dataset.enhanced = 'true';
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veylston-product-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('v-product-stories')) {
    customElements.define('v-product-stories', class extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-desktop-carousel') || this.controller) return;
        this.track = this.querySelector('.v-stories__rows');
        this.slides = Array.from(this.querySelectorAll('.v-stories__row'));
        this.links = Array.from(this.querySelectorAll('.v-stories__index-link'));
        if (!this.track || this.slides.length < 2) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.desktop = matchMedia('(min-width: 990px)');
        this.previous = this.querySelector('[data-story-previous]');
        this.next = this.querySelector('[data-story-next]');
        this.current = this.querySelector('[data-story-current]');
        this.querySelector('[data-story-total]').textContent = String(this.slides.length).padStart(2, '0');
        this.index = 0;
        this.previous.addEventListener('click', () => this.go(this.index - 1), { signal });
        this.next.addEventListener('click', () => this.go(this.index + 1), { signal });
        this.links.forEach(link => link.addEventListener('click', event => {
          if (!this.desktop.matches) return;
          const index = this.slides.findIndex(slide => '#' + slide.id === link.getAttribute('href'));
          if (index < 0) return;
          event.preventDefault();
          this.go(index);
        }, { signal }));
        this.track.addEventListener('keydown', event => {
          if (!this.desktop.matches || event.target !== this.track) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          let index = this.index;
          if (event.key === 'ArrowRight') index += rtl ? -1 : 1;
          else if (event.key === 'ArrowLeft') index += rtl ? 1 : -1;
          else if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = this.slides.length - 1;
          else return;
          event.preventDefault();
          this.go(index);
        }, { signal });
        this.track.addEventListener('scroll', () => {
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => {
            if (!this.desktop.matches) return;
            const rtl = getComputedStyle(this.track).direction === 'rtl';
            const edge = rtl ? 'right' : 'left';
            const origin = this.track.getBoundingClientRect()[edge];
            this.index = this.slides.reduce((best, slide, index) => Math.abs(slide.getBoundingClientRect()[edge] - origin) < Math.abs(this.slides[best].getBoundingClientRect()[edge] - origin) ? index : best, 0);
            this.updateControls();
          }, 160);
        }, { signal, passive: true });
        this.desktop.addEventListener('change', () => this.configure(), { signal });
        this.observer = new ResizeObserver(() => {
          if (this.desktop.matches) this.go(this.index, false);
        });
        this.configure();
        this.observer.observe(this.track);
      }
      configure() {
        this.toggleAttribute('data-carousel-ready', this.desktop.matches);
        if (this.desktop.matches) {
          this.track.tabIndex = 0;
          this.track.setAttribute('role', 'region');
          this.go(this.index, false);
        } else {
          this.track.removeAttribute('tabindex');
          this.track.removeAttribute('role');
          this.track.scrollTo({ left: 0, behavior: 'instant' });
          this.links.forEach(link => link.removeAttribute('aria-current'));
        }
      }
      go(index, animate = true) {
        this.index = Math.max(0, Math.min(index, this.slides.length - 1));
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const edge = rtl ? 'right' : 'left';
        const distance = this.slides[this.index].getBoundingClientRect()[edge] - this.track.getBoundingClientRect()[edge];
        const smooth = animate && !matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.track.scrollLeft + distance, behavior: smooth ? 'smooth' : 'instant' });
        this.updateControls();
      }
      updateControls() {
        this.previous.disabled = this.index === 0;
        this.next.disabled = this.index === this.slides.length - 1;
        this.current.textContent = String(this.index + 1).padStart(2, '0');
        this.links.forEach(link => {
          if (link.getAttribute('href') === '#' + this.slides[this.index].id) link.setAttribute('aria-current', 'step');
          else link.removeAttribute('aria-current');
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        clearTimeout(this.settleTimer);
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
